import React from 'react';

export interface WixStyleReactMaskingProviderProps {
  children?: React.ReactNode;
}

export type WixStyleReactMaskingProviderContextProps = {
  maskingClassNames: string;
};
